/**
 * TOPのprofile
 * @constructor
 */
class Hover {
  constructor() {

  }
  /**
   * TOPのprofile
   */
  init() {
    const self = this;

    //プロフィールのランダム
    var num = Math.ceil(11 * Math.random());
    $('.p-topProfMain__item--' + num).addClass('is-active');
    $('.p-topProfHoverArea__item--' + num).addClass('is-active');


    $('.js-select').on('mouseover', (e) => {
      this.changeProf(e.currentTarget);
      this.changeSelectBtn(e.currentTarget);
    });

  }
  
  
  changeProf(el) {
    const num = $(el).data('img');
    if (num != 12) {
      $('.p-topProfMain__item').removeClass('is-active');
      $('.p-topProfMain__item--' + num).addClass('is-active');
    }
  }
  
  changeSelectBtn(el) {
    $('.p-topProfHoverArea__item').removeClass('is-active');
    $(el).addClass('is-active');
  }
}
export default Hover;
